export default class GiftModel {
    constructor() {
        this.Email = ""
        this.AssetID = ""
        this.Phone = ""
    }
}